import React from "react";
import SvgIcon from "@mui/material/SvgIcon";

/** Side-view walk-behind mower — clear at 24×24, uses currentColor */
export default function LawnMowerIcon(props) {
  return (
    <SvgIcon viewBox="0 0 24 24" fontSize="medium" {...props}>
      {/* Handle: pole + T-grip */}
      <path
        fill="none"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M6.35 11.4c-1.55-1.3-2.5-3.25-2.5-5.4V4M2.85 3.25h4.35"
      />
      {/* Rear wheel */}
      <circle cx="8.4" cy="16.85" r="3.35" fill="currentColor" />
      <circle
        cx="8.4"
        cy="16.85"
        r="1.4"
        fill="none"
        stroke="currentColor"
        strokeWidth="0.85"
        opacity={0.4}
      />
      {/* Front wheel */}
      <circle cx="17.15" cy="17.05" r="2.6" fill="currentColor" />
      <circle
        cx="17.15"
        cy="17.05"
        r="1"
        fill="none"
        stroke="currentColor"
        strokeWidth="0.7"
        opacity={0.4}
      />
      {/* Cutting deck (sits over wheels) */}
      <path
        fill="currentColor"
        d="M5.25 15.4h13.9c.7 0 1.25-.55 1.25-1.25v-1.1c0-2.05-1.65-3.7-3.7-3.7H8.7c-1.2 0-2.3.6-2.9 1.6l-.9 1.5c-.35.55-.3 1.25.1 1.75l.45.55c.3.35.7.55 1.1.55z"
      />
      {/* Grass-catcher / engine housing */}
      <path
        fill="currentColor"
        d="M10.85 7.15h6.35c.65 0 1.15.5 1.15 1.15v2.55h-7.5c-.5 0-.95-.3-1.15-.75l-.4-.85c-.2-.45 0-.95.4-1.2l.5-.3c.35-.2.75-.3 1.15-.3z"
        opacity={0.88}
      />
      {/* Deck highlight */}
      <path
        fill="none"
        stroke="currentColor"
        strokeWidth="1.05"
        strokeLinecap="round"
        opacity={0.45}
        d="M6.2 15.4h5.5"
      />
    </SvgIcon>
  );
}
